import {
  allPass,
  always,
  equals,
  filter,
  findLast,
  head,
  ifElse,
  juxt,
  last,
  path,
  pipe,
  prop,
  propEq,
} from "ramda";
import { eventTypes } from "../lib/analytics";

const statusTypes = {
  ENDED: "ended",
  LIVE: "live",
  PENDING_AN_AGENT: "Pending an agent",
  PENDING_YOUR_REPLY: "Pending your reply",
  IN_PROGRESS: "In progress",
};

const gethandoffSwitchCommand = (conversationHistory) =>
  conversationHistory.filter(
    allPass([
      propEq("type", eventTypes.SWITCH_COMMAND),
      pipe(path(["data", "commandType"]), equals("add")),
      pipe(path(["data", "data", "id"]), equals("liveAgentConnector")),
    ])
  );

const getChatHistory = (conversationHistory) =>
  conversationHistory.filter(
    (u) =>
      (u.type === eventTypes.USER_UTTERANCE && u.data.utterance) ||
      u.type === eventTypes.BOT_UTTERANCE
  );

const getConversationRequestTime = pipe(
  gethandoffSwitchCommand,
  head,
  prop("createdAt")
);

const getLastUserMessageTime = pipe(
  findLast(propEq("type", eventTypes.USER_UTTERANCE)),
  prop("createdAt")
);

const getLastAgentMessageTime = pipe(
  findLast(propEq("type", eventTypes.BOT_UTTERANCE)),
  prop("createdAt")
);

const getConversationMetadata = pipe(
  gethandoffSwitchCommand,
  head,
  path(["data", "data", "metadata"])
);

const getConversationStatus = juxt([
  pipe(
    filter(
      allPass([
        propEq("type", eventTypes.SWITCH_COMMAND),
        pipe(path(["data", "commandType"]), equals("disconnect")),
      ])
    ),
    last,
    ifElse(
      pipe(path(["data", "sender"]), equals("liveAgentConnector")),
      always(statusTypes.ENDED),
      always(statusTypes.LIVE)
    )
  ),
  pipe(
    findLast(
      (e) =>
        e.type === eventTypes.BOT_UTTERANCE ||
        e.type === eventTypes.USER_UTTERANCE
    ),
    (lastUtterance) =>
      ({
        USER_UTTERANCE: () => statusTypes.PENDING_YOUR_REPLY,
        BOT_UTTERANCE: (data) =>
          data.sender === "liveAgent"
            ? statusTypes.IN_PROGRESS
            : statusTypes.PENDING_YOUR_REPLY,
      }[lastUtterance.type](lastUtterance.data))
  ),
]);

export {
  getChatHistory,
  getConversationRequestTime,
  getLastAgentMessageTime,
  getLastUserMessageTime,
  getConversationMetadata,
  getConversationStatus,
  statusTypes,
};
